<template>
  <panel
    :breadcrumbs="breadcrumbs"
    :title="title"
  >
    <v-toolbar card>
      <v-spacer />
      <v-text-field
        v-model="search"
        append-icon="search"
        label="Search"
      />
    </v-toolbar>
    <v-alert
      :value="alert"
      :type="alertType"
      transition="scale-transition"
    >
      {{ alertMessage }}
    </v-alert>
    <v-data-table
      :headers="headers"
      :items="items"
      :loading="loading"
      :search="search"
      item-key="name"
      class="elevation-1"
      disable-initial-sort
    >
      <template #items="props">
        <tr>
          <td class="text-xs-left">
            {{ props.item.dealer_id }}
          </td>

          <td class="text-xs-left">
            {{ props.item.nama }}
          </td>

          <td class="text-xs-left">
            {{ formatDate(props.item.lastUpdate) }}
          </td>
        </tr>
      </template>
    </v-data-table>
  </panel>
</template>

<script>
import { createGetParams } from '@/rest'

const pageTitle =
  'Attendance Dealer Course'

export default {
  components: {
    Panel: () => import(/* webpackChunkName: "panel" */ '@/components/Panel'),
  },
  data () {
    return {
      alert: false,
      alertMessage: null,
      alertType: 'error',
      breadcrumbs: [
        {
          text: 'DMT Kits', disabled: false, to: '/support/dmt_kits',
        },
        {
          text: pageTitle, disabled: true,
        },
      ],
      items: [],
      headers: [
        {
          text: 'Dealer ID',
          align: 'left',
          sortable: true,
          value: 'dealer_id',
        },
        {
          text: 'Name',
          align: 'left',
          sortable: true,
          value: 'nama',
        },
        {
          text: 'Last Update',
          align: 'left',
          sortable: true,
          value: 'lastUpdate',
        },
      ],
      loading: false,
      search: '',
      title: pageTitle,
    }
  },
  mounted: function () {
    this.getDealerCourseListing()
  },
  methods: {
    formatDate (date) {
      if (!date) {
        return '-'
      }

      return new Date(date)
        .toLocaleDateString('en-GB')
    },
    getDealerCourseListing: function () {
      this.loading = false
      this.alert = false
      this.$rest.get('getDealerCourseListing.php', createGetParams())
        .then(function (response) {
          this.items = response.data
        }.bind(this)).catch(error => {
          let message = error.message
          if (error.response) {
            message += ': ' + error.response.data
          }
          this.alertMessage = message
          this.alert = true
          this.loading = false
        })
    },
  },
}
</script>
